import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {GenericResponse, PaginatedResponse, Response} from '../../_models/response.model';
import {query} from '@angular/animations';
import {IPspPatientDTO, IPspSubscriptionDTO} from '../../_models/patient.model';

@Injectable({
  providedIn: 'root'
})
export class PspSubscriptionService {
  private baseUrl = 'api/AdminPspSubscriptions';

  constructor(private http: HttpClient) {
  }

  updateSubscriptionStatus(
    oldStatusId: number,
    statusId: number,
    subscriptionId: number,
    reason: string
  ): Observable<GenericResponse<any>> {
    return this.http.put<GenericResponse<any>>(`${this.baseUrl}/UpdatePspSubscriptionStatus`, {
      StatusId: statusId,
      OldStatusId: oldStatusId,
      SubscriptionId: subscriptionId,
      Reason: reason
    });
  }

  updateSubscriptionHistory(
    subscriptionId: number,
    history: string
  ): Observable<GenericResponse<any>> {
    return this.http.put<GenericResponse<any>>(`${this.baseUrl}/UpdateSubscriptionHistory`, {
      SubscriptionId: subscriptionId,
      SubscriptionHistory: history
    });
  }
  getAllPaginated(params: any): Observable<PaginatedResponse<IPspSubscriptionDTO>> {
    return this.http.get<PaginatedResponse<IPspSubscriptionDTO>>(`${this.baseUrl}/GetAll`, {params});
  }

  getAllReport(params?: any): Observable<Response<any[]>> {
    return this.http.get<Response<IPspPatientDTO[]>>(`${this.baseUrl}/GetAllReport`, {params});
  }
}
